import { useAppDispatch } from '@/store'
import { Dialog, Icon } from '@/shared/ui'
import { setDialogs } from '@/store/sub_accounts'
import { VERIFICATION_PENDING_ALERT } from '@/entities/cabinet'
import style from '@/features/cabinet/ui/cabinet-alert-components/index.module.scss'

export function VerificationPendingAlert() {
    const dispatch = useAppDispatch()
    return (
        <Dialog
            title={''}
            hideCloseBtn={true}
            onClose={() =>
                dispatch(
                    setDialogs({
                        key: VERIFICATION_PENDING_ALERT,
                        value: false,
                    })
                )
            }
            body={
                <div className={style.verification}>
                    <div>
                        <img
                            src={require('@/cabinet/images/time.png')}
                            alt={'time'}
                        />
                    </div>
                    <div className={style.verification__content}>
                        <h5 className={style.verification__content__title}>
                            {' '}
                            Omanhash Verification Pending
                        </h5>
                        <p className={style.verification__content__description}>
                            Your registration has been received and is currently
                            under review. <br /> You’ll be able to start mining
                            once your account is approved.
                        </p>
                    </div>
                </div>
            }
        />
    )
}
